/* =====================
   Ajoutez ici votre propre javascript personnalisé
   ===================== */

/* =========================================================
   Cartes produit : changer la photo au clic sur une pastille
   de couleur.

   Délégation d'événement sur `document` : les cartes ajoutées
   après le chargement (pagination infinie, filtres, carrousel
   Splide, recherche) sont prises en charge sans ré-init.

   Le lien de la pastille reste fonctionnel : un simple clic
   change l'image, mais Ctrl/Cmd/clic milieu ou un second clic
   sur la pastille déjà active ouvrent la page produit.
   ========================================================= */
(function () {
  "use strict";

  const SWATCH_LINK = ".product-item .color-swatches a[data-swatch-image]";

  document.addEventListener("click", function (event) {
    const link = event.target.closest(SWATCH_LINK);
    if (!link) return;

    // Laisser passer les clics "ouvrir dans un nouvel onglet".
    if (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    ) {
      return;
    }

    const card = link.closest(".product-item");
    if (!card) return;

    const mainImage = card.querySelector(".product-item-img:not(.product-item-img-hover)");
    if (!mainImage) return;

    const newSrc = link.getAttribute("data-swatch-image");
    if (!newSrc) return;

    // Deuxième clic sur la pastille active : on suit le lien.
    if (link.classList.contains("is-active")) return;

    event.preventDefault();

    // Mémoriser l'image d'origine pour pouvoir la restaurer.
    if (!mainImage.dataset.originalSrc) {
      mainImage.dataset.originalSrc = mainImage.getAttribute("src");
      mainImage.dataset.originalAlt = mainImage.getAttribute("alt") || "";
    }

    // La 2e image (survol) masquerait la nouvelle photo : on la retire.
    const hoverImage = card.querySelector(".product-item-img-hover");
    if (hoverImage) hoverImage.style.display = "none";

    mainImage.setAttribute("src", newSrc);
    mainImage.setAttribute(
      "alt",
      link.getAttribute("data-swatch-image-alt") || mainImage.dataset.originalAlt
    );

    // Marquer la pastille sélectionnée.
    card
      .querySelectorAll(".color-swatches a.is-active")
      .forEach((el) => el.classList.remove("is-active"));
    link.classList.add("is-active");

    // Le lien "voir le produit" pointe désormais sur la variante choisie.
    const productLink = card.querySelector("a.product-link");
    if (productLink) productLink.setAttribute("href", link.getAttribute("href"));
  });
})();
